"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatform = void 0;
var getPlatform = function () {
    if (navigator.platform.toUpperCase().includes('MAC')) {
        // for mac
        return 'mac';
    }
    if (navigator.platform.toUpperCase().includes('WIN')) {
        // for windows
        return 'windows';
    }
    return 'other';
};
exports.getPlatform = getPlatform;
